import { SVGIconComponent } from './types';

export const StatusInProgress: SVGIconComponent = ({ className, color, style }) => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    style={{ color, ...style }}
    className={className}
  >
    <g id="timeline/status-inprogress" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M4.51016198,10 C5.89690953,10 7.021141,11.1193159 7.021141,12.5 C7.021141,13.8806841 5.89690953,15 4.51016198,15 C3.12341442,15 2,13.8806841 2,12.5 C2,11.1193159 3.12343485,10 4.51016198,10 Z M12,10 C13.3867476,10 14.510979,11.1193159 14.510979,12.5 C14.510979,13.8806841 13.3867476,15 12,15 C10.6132524,15 9.48902098,13.8806841 9.48902098,12.5 C9.48902098,11.1193159 10.6132524,10 12,10 Z M19.489838,10 C20.8765856,10 22,11.1193159 22,12.5 C22,13.8806841 20.8765651,15 19.489838,15 C18.1030905,15 16.978859,13.8806841 16.978859,12.5 C16.978859,11.1193159 18.1030905,10 19.489838,10 Z"
        id="Combined-Shape"
        fill="currentColor"
        fillRule="nonzero"
      ></path>
    </g>
  </svg>
);
